import {
  ActivityValueChange,
  ValueChangeActivityCard,
} from "@adsk/alloy-react-activity-log";
import React from "react";
import { useTranslations } from "@adsk/acc-issues-translations";
import { ActivityLogCardProps } from "../activityLogTypes";

export const ChangedValueActivityCard = ({
  activityChange,
  isAggregated,
  getDisplayText = (x: any) => x,
  ...props
}: ActivityLogCardProps & {
  getDisplayText?: (str: any) => React.ReactNode;
}) => {
  const { T } = useTranslations();
  const { before, after } = activityChange;
  const activityBeforeText = before ? getDisplayText(before) : undefined;
  const activityAfterText = after
    ? getDisplayText(after)
    : T.translate("activityLog.none");

  return isAggregated ? (
    <ActivityValueChange
      before={activityBeforeText}
      after={activityAfterText}
    />
  ) : (
    <ValueChangeActivityCard
      /* Used by globals.ts to amend UI issues until https://jira.autodesk.com/browse/WPLT-1164 is fixed */
      className="IssuesActivityLog__activity-card"
      before={activityBeforeText}
      after={activityAfterText}
      {...props}
      data-testid="value-activity-card"
    />
  );
};
